/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import LazyLoadController from '@meteora-digital/lazy';

/* --------------------------------------------------
Lazy Load Images
-------------------------------------------------- */

// Create a new LazyLoadController
const LazyLoad = new LazyLoadController();

// Create a new watcher to watch for new data-picture-src elements
const PictureWatcher = new Watcher();

// When a new picture is found
PictureWatcher.on('update', pictures => {
  pictures.forEach(element => {
    // const src = element.getAttribute('data-src');
    const pic = element.querySelector('picture img');

    // If the src is not picture, return;
    // if (src !== 'picture') return;
    // if there is no picture img element, return;
    if (!pic) return;

    // Set the data-src of the element to the current src of the picture element
    element.setAttribute('data-src', pic.currentSrc || pic.src);
    LazyLoad.update();
  });
});

// // We are going to look for any element with a data-src attribute that matches the value of picture
// // We will then grab the current picture src and set it as the data-src of the element, in order to lazy load the correct size
// [...document.querySelectorAll('[data-src]')].forEach((element) => {

// });

// Watch for new pictures
PictureWatcher.watch('[data-picture-src]');

// Lazy load elements with this selector
LazyLoad.watch('[data-src]');